import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { RenterDashboardLayoutComponent } from "./renter-dashboard-layout/renter-dashboard-layout.component";
import { ManageSharedModule } from "../../manage-shared/manage-shared.module";

const routes: Routes = [
  {
    path: "",
    component: RenterDashboardLayoutComponent,
  },
];
@NgModule({
  declarations: [RenterDashboardLayoutComponent],
  imports: [CommonModule, RouterModule.forChild(routes), ManageSharedModule],
})
export class RenterDashboardModule {}
